import Address from '@components/address';
import ComponentBlock from '@components/component-block';
import Card from '@components/contact-info/components/card';
import Container from '@components/container';
import TextBlock from '@components/text-block';
import { Yeseva } from 'app/fonts';
import classNames from 'classnames';
import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import type ContactInformation from 'types/contact-information';
import { validateString } from 'utils/validate-string';

import styles from './contact-info.module.scss';

const rootClass = validateString(styles.root);
const cardClass = validateString(styles.card);
const contentClass = validateString(styles.content);
const headingClass = validateString(styles.heading);
const contactInfoClass = validateString(styles.contactInfo);

interface Props {
  readonly description?: ReactNode | undefined;
  readonly eyebrow?: ReactNode | undefined;
  readonly heading?: ReactNode | undefined;
  readonly subHeading?: ReactNode | undefined;
  readonly contactInformation: ContactInformation;
  readonly businessName?: string | undefined;
}

export default function ContactInfo({
  businessName,
  contactInformation,
  description,
  eyebrow,
  heading,
  subHeading,
}: Props): ReactElement {
  return (
    <ComponentBlock>
      <Container className={rootClass}>
        <div className={contentClass}>
          <TextBlock
            description={description}
            eyebrow={eyebrow}
            heading={heading}
            layout="center"
            subHeading={subHeading}
          />
          <div className={contactInfoClass}>
            <Card className={cardClass}>
              <h3 className={classNames(headingClass, Yeseva.className)}>
                Phone
              </h3>
              <a href={`tel:${contactInformation.phone}`}>
                {contactInformation.phone}
              </a>
            </Card>

            <Card className={cardClass}>
              <h3 className={classNames(headingClass, Yeseva.className)}>
                Address
              </h3>
              <Address
                directions
                {...contactInformation.address}
                businessName={businessName}
              />
            </Card>

            <Card className={cardClass}>
              <h3 className={classNames(headingClass, Yeseva.className)}>
                Email
              </h3>
              <a href={`mailto:${contactInformation.email}`}>
                {contactInformation.email}
              </a>
            </Card>
          </div>
        </div>
      </Container>
    </ComponentBlock>
  );
}
